import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

type SidebarCardFallbackProps = {
  /** The card's display name, when the failing card is known. */
  readonly label?: string;
};

/**
 * Shown in place of any sidebar card whose rendering threw, so one failing card
 * cannot take the conversation view down with it.
 */
export const SidebarCardFallback = ({
  label,
}: SidebarCardFallbackProps): JSX.Element => {
  const message = label ? (
    <>
      <strong>{label}</strong> could not be loaded.
    </>
  ) : (
    'This sidebar widget could not be loaded.'
  );

  return (
    <FlexBox padding="300 400" alignItems="center">
      <FlexBox margin="0 300 0 0" alignItems="center">
        <Icon
          color={colors.red[500]}
          size={16}
          name="exclamation-triangle-filled"
        />
      </FlexBox>

      <Text.Paragraph color="secondary">{message}</Text.Paragraph>
    </FlexBox>
  );
};
